import { Action } from '@ngrx/store';

import { type } from '@nuso/common/util-state';
import { Customer } from '@nuso/orgs/types';

export interface CustomerNavigationContext {
  customer: Customer;
  sessionInfo?: any;
  bridgeRedirectPath?: string;
  skipNavigation?: boolean;
}

export const ActionTypes = {
  SET_LOGIN_STATE: type('[Login] Set Login State From Service'),
  ATTEMPT_LOGIN: type('[Login] Attempt Login'),
  ATTEMPT_LOGIN_WITH_RESET_TOKEN: type('[Login] Attempt password reset token login'),
  IMPERSONATE_USER: type('[Login] Impersonate User attempt'),
  STOP_IMPERSONATING_USER: type('[Login] Stop impersonating user'),
  REFRESH_TOKEN: type('[Login] Refresh Login Token'),
  RECEIVE_SESSION_INFO: type('[Login] Receive Session Info'),
  FAIL_LOGIN: type('[Login] Fail Login'),
  LOGOUT: type('[Login] Logout'),
  SET_REDIRECT_URL: type('[Login] Set Redirect URL'),
  SESSION_EXPIRED: type('[Login] Session Expired'),
  RESET_REDIRECT_URL: type('[Login] Reset Redirect URL'),
  SET_CURRENT_CUSTOMER: type('[Login] Set Current Customer'),
  SET_RETURNED_CURRENT_CUSTOMER: type('[Login] Set Returned Current Customer'),
  SET_CURRENT_CUSTOMER_REDIRECT_URL: type('[Login] Set redirect url when set current customer'),
  SET_FAILED_CURRENT_CUSTOMER: type('[Login] Set Failed Current Customer'),
  UPDATE_CURRENT_CUSTOMER: type('[Login] Update who the customer is with custom redirect.'),
  TRIGGER_CUSTOMER_NAVIGATION: type('[Login] Trigger Customer Navigation with Context')
};

// Used to transition away from ngrx-store to a login service
// We are creating an adapter that will set the state of the store
// from the login service, so we can slowly migrate away clients that
// are selecting from the store
export class SetLoginStateAction implements Action {
  type = ActionTypes.SET_LOGIN_STATE;

  constructor(public payload: any) {}
}


export class AttemptLoginAction implements Action {
  type = ActionTypes.ATTEMPT_LOGIN;

// TODO: type out LoginCredentials and use instead of any
  constructor(public payload: any) {}
}

export class AttemptLoginWithResetTokenAction implements Action {
  type = ActionTypes.ATTEMPT_LOGIN_WITH_RESET_TOKEN;

  constructor(public payload: string) {}
}

export class ImpersonateUserAction implements Action {
  type = ActionTypes.IMPERSONATE_USER;

  // userId: number
  constructor(public payload: number) {
  }
}

export class StopImpersonatingUserAction implements Action {
  type = ActionTypes.STOP_IMPERSONATING_USER;

  constructor() {}
}

export class RefreshLoginTokenAction implements Action {
  type = ActionTypes.REFRESH_TOKEN;

  constructor(public payload: string) { }
}

export class ReceiveSessionInfoAction implements Action {
  type = ActionTypes.RECEIVE_SESSION_INFO;

// TODO: type out LoginResponse and use instead of any
  constructor(public payload: any) {
    console.log('RECEIVE_SESSION_INFO', payload);
  }
}

export class FailLoginAction implements Action {
  type = ActionTypes.FAIL_LOGIN;

  constructor(public payload: string) {}
}

export class LogoutAction implements Action {
  type = ActionTypes.LOGOUT;

  constructor() {}
}

export class SessionExpiredAction implements Action {
  type = ActionTypes.SESSION_EXPIRED;

  constructor() {}
}

export class SetRedirectUrlAction implements Action {
  type = ActionTypes.SET_REDIRECT_URL;

  constructor(public payload: string) {}
}

export class ResetRedirectUrlAction implements Action {
  type = ActionTypes.RESET_REDIRECT_URL;

  constructor() {}
}

export class SetCurrentCustomerRedirectUrlAction implements Action {
  type = ActionTypes.SET_CURRENT_CUSTOMER_REDIRECT_URL;

  constructor(public payload: string | null) {}
}

export class SetCurrentCustomerAction implements Action {
  type = ActionTypes.SET_CURRENT_CUSTOMER;

  constructor(public payload: number) {}
}

export class SetReturnedCurrentCustomerAction implements Action {
  type = ActionTypes.SET_RETURNED_CURRENT_CUSTOMER;

  constructor(public payload: Customer) {}
}

export class UpdateCurrentCustomerAction implements Action {
  type = ActionTypes.UPDATE_CURRENT_CUSTOMER

  constructor(public payload: Customer) {}
}

export class SetFailedCurrentCustomerAction implements Action {
  type = ActionTypes.SET_FAILED_CURRENT_CUSTOMER;

  constructor(public payload: any) {}
}

export class TriggerCustomerNavigationAction implements Action {
  type = ActionTypes.TRIGGER_CUSTOMER_NAVIGATION;

  constructor(public payload: CustomerNavigationContext) {}
}


export type Actions
  = SetLoginStateAction
  | AttemptLoginAction
  | AttemptLoginWithResetTokenAction
  | ImpersonateUserAction
  | StopImpersonatingUserAction
  | RefreshLoginTokenAction
  | ReceiveSessionInfoAction
  | FailLoginAction
  | LogoutAction
  | SessionExpiredAction
  | SetRedirectUrlAction
  | SetCurrentCustomerAction
  | SetReturnedCurrentCustomerAction
  | SetFailedCurrentCustomerAction
  | TriggerCustomerNavigationAction
;
